import { render, staticRenderFns } from "./goodsList_ec_sVs.vue?vue&type=template&id=788c3a07&scoped=true&"
import script from "./goodsList_ec_sVs.vue?vue&type=script&lang=js&"
export * from "./goodsList_ec_sVs.vue?vue&type=script&lang=js&"
import style0 from "./goodsList_ec_sVs.vue?vue&type=style&index=0&id=788c3a07&lang=less&scoped=true&"
import style1 from "./goodsList_ec_sVs.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788c3a07",
  null
  
)

component.options.__file = "goodsList_ec_sVs.vue"
export default component.exports